import { render, staticRenderFns } from "./MonthReceivableList.vue?vue&type=template&id=cc0ec020&scoped=true"
import script from "./MonthReceivableList.vue?vue&type=script&lang=js"
export * from "./MonthReceivableList.vue?vue&type=script&lang=js"
import style0 from "./MonthReceivableList.vue?vue&type=style&index=0&id=cc0ec020&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc0ec020",
  null
  
)

export default component.exports